import { BooleanField, NumberField } from 'react-admin';

import { GetInstrumentOneResponse } from '@Common/types/bo/instruments';

import { ShowFields, ShowSection } from '@sh4res/bo-common/components';
import { CountriesStatusList } from '@sh4res/bo-common/components/Instruments/countries_status/CountriesStatusList';
import { UTCDateField } from '@sh4res/bo-common/fields';

export const CcbSection = ({ isExternalBo }: { isExternalBo: boolean }) => (
  <>
    {!isExternalBo && (
      <ShowSection label="resources.bo_common.instruments.sections.statuses">
        <ShowFields<GetInstrumentOneResponse & { country_settings: string }>
          fields={{
            country_settings: <CountriesStatusList mode="list" />,
          }}
        />
      </ShowSection>
    )}
    <ShowSection label="resources.bo_common.instruments.sections.other">
      <ShowFields<GetInstrumentOneResponse>
        fields={{
          qty_decimal_places: (
            <NumberField data-testid="BoExternalCcbSection_QtyDecimalPlacesField" />
          ),
          ccb_last_vl_date: <UTCDateField data-testid="BoExternalCcbSection_CcbLastVlDateField" />,
          ...(!isExternalBo && {
            has_close_price: <BooleanField data-testid="BoExternalCcbSection_HasClosePriceField" />,
          }),
        }}
      />
    </ShowSection>
  </>
);
